import React, { SyntheticEvent, useEffect, useState } from "react";
import { get_portfolio_select } from "../../Axios";
import { useNavigate } from "react-router-dom";
import noImage from "../../assets/images/no_image_angle.png";

const PortfolioSummary: React.FC = () => {
    const navigate = useNavigate();
    const [portfolioList, setPortfolioList] = useState<any[]>([]);

    const square_meter_query = {
        min_value: 0,
        max_value: 11,
        including_square_meter_unregistered: true,
    };

    useEffect(() => {
        get_portfolio_select(0, 0, 1, "", 0, "", true, square_meter_query).then(result => {
            setPortfolioList(result.rows);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const addNoImage = (e: SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = noImage;
    };
    
    return (
        <div className="grid grid-cols-4 gap-4">
            {Array.from({ length: 8 }, (_, index) => {
                const portfolio = portfolioList[index];
                if (!portfolio) return null;
                
                return (
                    <div key={index} className="overflow-hidden w-full aspect-square">
                        <img
                            onClick={() => navigate('/portfolio_select_one', {state : {ablack_comunity_ID : portfolio.ablack_comunity_ID}})}
                            className="w-full h-full object-cover"
                            src={portfolio.ablack_comunity_thumbnail_img}
                            onError={addNoImage}
                            alt=""
                        />
                    </div>
                );
            })}
        </div>
    )
};

export default PortfolioSummary;